
export const GET_PRODUCT_LIST :string = "/Products";
export const GET_USER_PRODUCT_LIST :string = "/Products";
export const GET_PRODUCT_DETAIL :string = "/ProductsDetail";
export const REGISTER_BOOKMARK :string = "/RegisterBookmark";
export const GET_CALCULATED_PRICE :string = "/CalculateProductPrice";
export const DELETE_PRODUCT :string = "/deleteProduct";
export const REGISTER_BORROW_REQUEST :string = "/BorrowRequest/SendBorrowRequest";

